<template>
  <div class="mj_content">
    <div class="content_tabs" flex-center>
      <div class="tabs_wrap">
        <div @click="select_tab=tab.type" flex-center :class="['tabs_item',{'active':select_tab==tab.type}]"
             v-for="tab in tabs">{{ tab.name }}
        </div>
      </div>
    </div>
    <div class="content_body">
      <advancedOptions v-if="select_tab==1" :sampleList="sampleList" @select_sample="selectSample"
                       @submitForm="submitForm"></advancedOptions>
      <msglist ref="msgList" v-else></msglist>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import AdvancedOptions from 'COMPONENTS/pika/AdvancedOptions'
import Msglist from 'COMPONENTS/pika/Msglist'

export default {
  components: {AdvancedOptions, Msglist},
  data() {
    return {
      tabs: [{name: "创作中心", type: 1}, {name: "生成记录", type: 2}],
      select_tab: 1,
      sampleList: [],
      loading: true
    }
  },
  created() {
    // this.fettchSampleList();
  },
  methods: {
    fettchSampleList() {
      // 获取样例数据
      this.$http.get('/front/aivideo/sample/?soft=2', {params: {max_mj_id: this.max_mj_id}}).then((res) => {
        this.sampleList = res.data.item_list;
        this.loading = false;
      })
    },
    selectSample(item) {
      this.select_tab = 2
    },
    submitForm(data) {
      this.select_tab = 2
    },

  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.mj_content {
  display: flex;
  flex-direction: column;
  height: 100%;

  .content_tabs {
    height: 48px;
    margin-top: 5px;
    border-bottom: 1px solid #26282c;

    .tabs_wrap {
      width: 210px;
      padding: 3px;
      color: #fff;
      background-color: #292929;
      display: flex;
      justify-content: space-between;
      border-radius: 999px;

      .tabs_item {
        height: 31px;
        width: 100px;
        border-radius: 999px;

        &.active {
          font-weight: 700;
          background-color: #5865f2;
        }
      }
    }
  }

  .content_body {
    background-color: #1d2027;
    overflow: hidden;
    flex: 1 1 0%;
    white-space: nowrap;
    text-overflow: ellipsis;

  }
}
</style>